import { Link } from 'react-router-dom';
import { categories } from '@/mocks/welfare';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">福利分类导航</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">按类别快速查找你需要的福利资源</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.filter((c) => c.id !== 'all').map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="bg-background-50 border border-background-200 rounded-xl p-5 text-center hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-400">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}